import { useAppDispatch } from '../../store/store';
import { authActions } from '../../store/slices/auth';
import { SUPPORT_EMAIL } from '../../constants/legal';
import type { Ir } from '../porta';

// A CONTA BLOQUEADA POR DECLARAÇÃO DE MENORIDADE — a lógica do antigo `Consent/Blocked`.
// Nada foi apagado: a conta fica em revisão manual, e o caminho de volta (um e-mail ao suporte,
// que é também o canal do Encarregado de dados) está escrito na tela.
// Mora no núcleo desde 01/11/2026 (docs/PLANO-APP-NATIVO.md): a web e o app usam a mesma regra.

export const useContaBloqueada = ({ ir: navigate }: { ir: Ir }) => {
  const dispatch = useAppDispatch();
  const assunto = encodeURIComponent('Revisão de conta bloqueada por idade');

  return {
    emailDoSuporte: SUPPORT_EMAIL,
    linkDoSuporte: `mailto:${SUPPORT_EMAIL}?subject=${assunto}`,
    sair: async () => {
      await dispatch(authActions.signOut());
      navigate('/login', { replace: true });
    },
  };
};
